export default "__VITE_ASSET__a77cb7f7__"